export default "__VITE_ASSET__a8ef5609__"